// @flow

import removePropertyFromObject from '../removePropertyFromObject';

export default (obj: Object, key: string, val: ?any): Object => {
  if (obj[key]) {
    return removePropertyFromObject(obj, key);
  }

  if (!val) {
    throw new Error('No value provided to be toggled in object');
  }

  return {
    ...obj,
    [key]: val,
  };
};
